export const APP_VERSION = "v1.0.14";
export const ENV = "LIVE";
const CONFIG = {
    LIVE: {
        BASE_URL: "https://ctapi.avfxcapital.com",
    },
    BETA: {
        BASE_URL: "https://api.algodeltafx.com"
    },
    LOCAL: {
        BASE_URL: "http://192.168.1.4:3002",
    }
};

export const { BASE_URL, } = CONFIG[ENV];
export const API_URL = `${BASE_URL}/api/v1`;

export const STRATEGY_IMAGE_PATH = `${BASE_URL}/strategy_logo`;
export const STRATEGY_ANALYSIS_URL = "https://copytrading.avfxcapital.com/trading-masters";
